var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 47,
    viewBox: "0 0 60 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_180_2554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7024 23.5C23.8399 23.5 26.8489 22.2621 29.0674 20.0585C31.2859 17.855 32.5323 14.8663 32.5323 11.75C32.5323 8.63371 31.2859 5.64505 29.0674 3.4415C26.8489 1.23794 23.8399 0 20.7024 0C17.5649 0 14.5559 1.23794 12.3374 3.4415C10.1188 5.64505 8.87245 8.63371 8.87245 11.75C8.87245 14.8663 10.1188 17.855 12.3374 20.0585C14.5559 22.2621 17.5649 23.5 20.7024 23.5ZM16.4787 27.9062C7.37522 27.9062 0 35.2316 0 44.2736C0 45.7791 1.2292 47 2.74491 47H38.6598C40.1756 47 41.4048 45.7791 41.4048 44.2736C41.4048 35.2316 34.0295 27.9062 24.926 27.9062H16.4787Z",
    fill: "#828284"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_180_2554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.6248 46.9994H44.5688C45.0409 46.1776 45.3207 45.2247 45.3207 44.2018V43.5024C45.3207 38.1957 42.9515 33.431 39.2184 30.2312C39.4282 30.2225 39.6293 30.2137 39.8391 30.2137H45.207C52.9967 30.2137 59.3088 36.5259 59.3088 44.3155C59.3088 45.8017 58.1023 46.9994 56.6248 46.9994ZM41.1243 24.6185C38.4141 24.6185 35.9661 23.5169 34.1914 21.7422C35.9137 19.4167 36.9278 16.5404 36.9278 13.428C36.9278 11.085 36.3508 8.87314 35.3279 6.93229C36.9541 5.7433 38.9561 5.03516 41.1243 5.03516C46.5359 5.03516 50.9159 9.41518 50.9159 14.8268C50.9159 20.2385 46.5359 24.6185 41.1243 24.6185Z",
    fill: "#BFBFBF",
    fillOpacity: 0.52
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_180_2554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.4048,
    height: 47,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_180_2554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.9524,
    height: 44.7619,
    fill: "white",
    transform: "translate(3.35547 2.23828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.51be14f470f3b32d10504679d0345ee1.svg";
export { ForwardRef as ReactComponent };